
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 33.94 38.39"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Laag_2","data-name":"Laag 2"}},[_c('g',{attrs:{"id":"Laag_1-2","data-name":"Laag 1"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M9 24.72a1.39 1.39 0 112.78 0v2.76a1.39 1.39 0 01-2.78 0z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M9 26.1a2.89 2.89 0 013-2.78h5v3.55a2 2 0 01-2 2h-5s-1-.45-1-1zM32.71 0h-8.44c-4.65 0-5.49 1.56-1.88 3.48 3 1.53 5.55 2.93 5.74 3.12a1.08 1.08 0 01.4.82v21.5a1 1 0 001 1h3.18a1.18 1.18 0 001.23-1.12V1.13A1.18 1.18 0 0032.71 0m-19.6 18.31l-2.18 1.59c-.9.65-.73 1.17.38 1.17H16c.56 0 .64-.26.19-.58z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M19.67 31.12H6.48a1.13 1.13 0 110-2.25 6.62 6.62 0 000-1v-4.55a1.12 1.12 0 01-.83-2L12.21 16a1.32 1.32 0 011.64 0l6.64 5.4a1 1 0 01.33 1.24 1.23 1.23 0 01-1.15.72h-.08a3.36 3.36 0 00-.08 1v4.55h.16a1.13 1.13 0 110 2.25m6.4-22.65H1.23A1.19 1.19 0 000 9.6v27.67a1.18 1.18 0 001.23 1.12h23.61a1.18 1.18 0 001.23-1.12zM9 0a1.19 1.19 0 00-1 .7c-.13.29-.09 0-.09 2.78 0 1.52 2.69 2.74 6 2.74h8.78L11 0H9"}})])])])
          )
        }
      }
    